import axios from 'axios';
import {
	APTOS_CONFIG,
	COIN_NAME,
	INDEXER_URL,
	MOVE_VALUE,
} from 'data/constant';

// Define types for the response structure
interface CoinData {
	data: {
		coin: {
			value: string;
		};
	};
}

interface Metadata {
	name: string;
	decimals: number;
	symbol: string;
	token_standard: string;
}

interface FungibleAssetBalance {
	amount: number;
	asset_type: string;
	metadata: Metadata;
}

interface Data {
	current_fungible_asset_balances: FungibleAssetBalance[];
}

interface Root {
	data: Data;
}

export const getAptosBalance = async (address: string): Promise<string> => {
	try {
		const response = await axios.get<CoinData>(
			`${APTOS_CONFIG.rpcUrl}/accounts/${address}/resource/0x1::coin::CoinStore%3C0x1::aptos_coin::AptosCoin%3E`,
		);

		if (response.data.data.coin.value === '0') {
			return '0';
		}

		return (parseInt(response.data.data.coin.value) / MOVE_VALUE)
			.toFixed(3)
			.toString();
	} catch (error) {
		return '0';
	}
};

export const getAptosIndexerBalance = async (
	address: string,
): Promise<string> => {
	try {
		const { data } = await axios.post<Root>(`${INDEXER_URL}/v1/graphql`, {
			query: '\n    query CoinsData($owner_address: String, $limit: Int, $offset: Int) {\n        current_fungible_asset_balances(\n            where: {owner_address: {_eq: $owner_address}}\n            limit: $limit\n            offset: $offset\n        ) {\n            amount\n            asset_type\n            metadata {\n                name\n                decimals\n                symbol\n                token_standard\n            }\n        }\n    }\n',
			variables: {
				owner_address: address,
				limit: 100,
				offset: 0,
			},
		});

		if (data.data.current_fungible_asset_balances.length === 0) {
			return '0';
		}

		const amount = data.data.current_fungible_asset_balances.reduce(
			(acc, curr) => {
				if (curr.metadata.name === COIN_NAME) {
					const numericAmount = Number(curr.amount);
					return acc + (isNaN(numericAmount) ? 0 : numericAmount);
				}
				return acc;
			},
			0,
		);

		return (amount / MOVE_VALUE).toFixed(3).toString();
	} catch (error) {
		return '0';
	}
};

export const fetchAgentPoolUserBalance = async (
	contractAddress: string,
	accountAddress: string,
) => {
	const requestData = {
		function: `${contractAddress}::agent_pool::balanceOf`,
		type_arguments: [],
		arguments: [accountAddress],
	};

	try {
		const response = await axios.post(
			APTOS_CONFIG.rpcUrl + '/view',
			requestData,
			{
				headers: {
					'Content-Type': 'application/json',
				},
			},
		);

		if (
			response.data.length &&
			(response.data[0] === '0' || response.data[0] === 0)
		)
			return '0';
		else {
			return `${parseInt(response.data[0]) / 100000000}`;
		}
	} catch (error) {
		return '0';
	}
};
